import type { Category } from '../types/game';

/** Laravel serializes `subCategories` as `sub_categories` when `$snakeAttributes` is true. */
export type ApiCategory = Category & {
  sub_categories?: ApiCategory[];
};

export function normalizeCategory(raw: ApiCategory): Category {
  const nested = raw.subCategories ?? raw.sub_categories;
  const subCategories = nested?.map(normalizeCategory);

  const { sub_categories: _snake, ...rest } = raw;

  return subCategories?.length
    ? { ...rest, subCategories }
    : { ...rest, subCategories: subCategories ?? rest.subCategories };
}

export function normalizeCategories(raw: ApiCategory[]): Category[] {
  return raw.map(normalizeCategory);
}

/** Subcategories for a parent, preferring nested data then optional fallback list. */
export function getSubcategoriesForParent(
  parent: Category | undefined,
  fallback?: Category[] | null
): Category[] {
  if (parent?.subCategories?.length) {
    return parent.subCategories;
  }
  return fallback ?? [];
}
